import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { class_returndata } from 'src/types/class_returndata'; 
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { BusyService } from '../_services/busy.service';

@Component({
  selector: 'app-scheduledsession',
  templateUrl: './scheduledsession.component.html',
  styleUrls: ['./scheduledsession.component.css']
})
export class ScheduledSessionsComponent  implements OnInit {
  ListScheduledSessions: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledClass: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService, private busyService: BusyService) {

    }

  onRowReorder(_event: any) {
    this.busyService.busy();

    // PrimeNG 13 reorders the array in-place before firing this event,
    // so we just assign displayorder from the already-correct positions.
    this.ListScheduledSessions.forEach((session, index) => {
      session.displayorder = index;
    });

    const reorderPayload = this.ListScheduledSessions.map(session => ({
      scheduledsessionid: session.scheduledsessionid,
      displayorder: session.displayorder
    }));

    this.http.post(bmxurl + "ScheduledSessionReorder", { venueid: this.VenueID, scheduledsessions: reorderPayload }).subscribe(() => {
      this.busyService.idle();
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while reordering Scheduled Sessions, error:' + error.messages[0]});
    });
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("CLASSES", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(ClassID)
  {
    this.http.delete(bmxurl + "scheduledsession/" + this.VenueID + "/" + ClassID).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded == true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Session successfully disabled'});
        this.router.navigateByUrl("/scheduledsession");

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Session'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "scheduledsessionList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.ListScheduledSessions = (response as any).data;

        this.ListScheduledSessions = this.ListScheduledSessions.sort((a, b) => (a.displayorder ?? 0) - (b.displayorder ?? 0));

        if ((response as any).messages.length > 0)
        {
          (response as any).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }

        this.ListScheduledSessions.forEach(element => {
          let participantReq = {
            venueid: this.VenueID,
            membershiptypeid: element.membershiptypeid,
            noofparticipants: 1
          }

          let CanGetMembershipInfo: boolean = true;
          let PartReqResponse: any;

          this.http.post(bmxurl + "membershipavailability", participantReq).subscribe(response => {

            PartReqResponse = (response as any);
            element.placesremaining = PartReqResponse.data.membershipfree; //PartReqResponse.data.membershipcount - PartReqResponse.data.membershipinprogress

          });
        });
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting ScheduledSessions, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting ScheduledSessions, error: ' + error.messages});
    });

  }

  stringifyDate(date: Date): string
  {
    let returnString = "";

    returnString = date.getFullYear() + "-" +  ('00' + (Number(date.getMonth()) + 1)).slice(-2) + "-" +  ('00' + date.getDate()).slice(-2);

    return returnString;
  }

  register(id)
  {
    this.router.navigateByUrl("/scheduledsessionregister/" + id);
  }

  copyData(id)
  {
    let newScheduledSession: any;

     this.http.get(bmxurl + "scheduledsession/" + this.VenueID + "/" + id).subscribe(response => 
      {
        this.httpResponse = response;

        newScheduledSession = {
          id: null,
          scheduledsessionid: null,
          name: this.httpResponse.data.name,
          disabled: this.httpResponse.data.disabled,
          venueid: this.VenueID,
          startdate: this.httpResponse.data.startdate,
          duration:  this.httpResponse.data.duration,
          numberofplaces: this.httpResponse.data.numberofplaces,
          numberofweeks: this.httpResponse.data.numberofweeks,
          maxbookings: this.httpResponse.data.maxbookings,
          description: this.httpResponse.data.description,
          imageurl: this.httpResponse.data.imageurl,
          price: this.httpResponse.data.price,
          colour: this.httpResponse.data.colour,
          questionaire: this.httpResponse.data.questionaire,
          emailtemplate: this.httpResponse.data.emailtemplate,
          originatingid: this.httpResponse.data.scheduledsessionid,
          membershipadmissions: this.httpResponse.data.membershipadmissions,
          resources: this.httpResponse.data.resources
        }

        this.http.post<any>(bmxurl + "/scheduledsession", newScheduledSession).subscribe(response => {
          this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.messageService.add({severity:'success', summary:'Saved', detail:'Copy successful'});
              this.editData(this.httpResponse.data.scheduledsessionid);
            }
            }, error => {
              this.messageService.add({severity:'error', summary:'Copy Failed', detail:error.messages});
          })
     });


  }

  editData(EditData)
  {
    let ScheduledSessionID = EditData;
    this.router.navigateByUrl("/scheduledsessionedit/" + ScheduledSessionID);
  }

  disableMulti()
  {
    // this.selectedItems.forEach(element => {

    // this.http.delete(bmxurl + "Class/" + this.VenueID + "/" + element.classID).subscribe(response => {
    //   this.httpResponse = response
    //   if(this.httpResponse.succeeded)
    //   {
    //     this.loadgrid(false);
    //   } 
    //   else{
    //     this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error disabling ScheduledSessions, error: ' + this.httpResponse.messages[0]});
    //   }
    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error disabling ScheduledSessions, error: ' + error.messages});
    // })
    // });
    
  }
  
  }
